/** Shared query-param builder for list endpoints. */

export interface ListQueryParams {
  page?: number;
  limit?: number;
  /** Field to sort by. Prefix with `-` for descending, e.g. `-createdAt`. */
  sort?: string;
  /** Free-text search term. */
  q?: string;
  /** Explicit named filters, appended as-is. */
  filters?: Record<string, string | number | boolean | undefined>;
}

/** Build a URLSearchParams from list query params, omitting empty values. */
export function buildQueryParams(params: ListQueryParams): URLSearchParams {
  const search = new URLSearchParams();

  if (params.page !== undefined) search.set("page", String(params.page));
  if (params.limit !== undefined) search.set("limit", String(params.limit));
  if (params.sort) search.set("sort", params.sort);
  if (params.q) search.set("q", params.q);

  if (params.filters) {
    for (const [key, value] of Object.entries(params.filters)) {
      if (value === undefined || value === "") continue;
      search.set(key, String(value));
    }
  }

  return search;
}
